import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('Level')
export class Level {

  @JsonProperty('level_id', Number)
  levelId: number = 0;

  @JsonProperty('level', Number)
  level: number = 0;

  @JsonProperty('next_level_experience_required', Number)
  nextLevelExperienceRequired: number = 0;

  @JsonProperty('next_level_reward', Number)
  nextLevelReward: number = 0;
}
